import { Box, OptionType, Spinner } from '@fullstory/components';
import { SnoozeUpdate } from '@fullstory/dqm-ui';
import { Issues, ValidateNamedElementResponse } from '@fullstory/proto/fs/services/dx-objects';
import { Classification } from '@fullstory/proto/fs/services/search-settings';
import React from 'react';
import { NamedElementEditableDetails } from '../../types';
import { NamedElementModalVariant } from '../NamedElementModal';
import { ModalBodyDetails as NamedElementModalBodyDetails } from '../NamedElementModal/NamedElementDetailsModal/ModalBodyDetails';

interface SidebarNamedElementProps {
  details: NamedElementEditableDetails | null;
  setDetails: (details: NamedElementEditableDetails | null) => void;
  setSnooze: (update: SnoozeUpdate) => void;
  issues: Issues.Issue[];
  selectedFsSpecObjectSlugs: OptionType<string>[];
  setSelectedFsSpecObjectSlugs: (selectedFsSpecObjectSlugs: OptionType<string, {}>[]) => void;
  selectedClassification?: Classification | null;
  classificationOptions: OptionType<Classification>[];
  loadingClassification: boolean;
  onClassificationChange: (classification: Classification | null) => void;
  fsSpecEnabled: boolean;
  fsSpecRoleOptions: OptionType<string>[];
  variant: NamedElementModalVariant;
  validation: ValidateNamedElementResponse | null;
  savedApiName: string;
  onHoverSelector: (selector?: string) => void;
  trimTrigger?: boolean;
  setTrimTrigger?: (off: boolean) => void;
  isSuggestion?: boolean;
}

export const SidebarNamedElement: React.FC<SidebarNamedElementProps> = ({
  details,
  setDetails,
  setSnooze,
  issues,
  selectedFsSpecObjectSlugs,
  setSelectedFsSpecObjectSlugs,
  selectedClassification,
  onClassificationChange,
  fsSpecEnabled,
  fsSpecRoleOptions,
  variant,
  validation,
  savedApiName,
  onHoverSelector,
  trimTrigger,
  setTrimTrigger,
  isSuggestion,
  classificationOptions,
  loadingClassification,
}) => {
  // TODO(clay): we really should be able to display the basic element details immediately w/o waiting
  //             and show appropriate loading for things that require the full detail view to come back
  if (!details) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        testId="sidebar-named-element-spinner"
      >
        <Spinner />
      </Box>
    );
  }

  return (
    <Box data-component="SidebarNamedElement" testId="sidebar-named-element">
      <NamedElementModalBodyDetails
        data-component="SidebarNamedElement"
        details={details}
        variant={variant}
        selectedFsSpecObjectSlugs={selectedFsSpecObjectSlugs}
        onChangeSelectedFsSpecSlugs={setSelectedFsSpecObjectSlugs}
        selectedClassification={selectedClassification}
        onClassificationChange={onClassificationChange}
        fsSpecEnabled={fsSpecEnabled}
        fsSpecRoleOptions={fsSpecRoleOptions}
        issues={issues}
        setDetails={setDetails}
        setSnooze={setSnooze}
        validation={validation}
        selectorFinding
        savedApiName={savedApiName}
        onHoverSelector={onHoverSelector}
        trimTrigger={trimTrigger}
        setTrimTrigger={setTrimTrigger}
        preventOverflow
        isSuggestion={isSuggestion}
        classificationOptions={classificationOptions}
        loadingClassification={loadingClassification}
      />
    </Box>
  );
};
